import { useEffect, useState } from 'react'

/** Below Tailwind's `lg` breakpoint (1024px). SSR-safe: starts `false`, resolves on mount. */
export const useIsMobile = (): boolean => {
	const [isMobile, setIsMobile] = useState(false)

	useEffect(() => {
		const checkMobile = () => {
			setIsMobile(window.innerWidth < 1024)
		}
		checkMobile()
		window.addEventListener('resize', checkMobile)
		return () => window.removeEventListener('resize', checkMobile)
	}, [])

	return isMobile
}
